import React, { useEffect, useState } from 'react';
import SwaggerUI from 'swagger-ui-react';
import { apiClient, swaggerRequestInterceptor } from 'src/clients/api-client';
import Loader from '@amzn/meridian/loader';
import 'swagger-ui-react/swagger-ui.css';

export const Swagger = () => {
  const [apiSpec, setApiSpec] = useState<string | object>({});
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    apiClient.get('/api-json')
      .then((response: { data: string | object }) => {
        setApiSpec(response.data);
      }).finally(() => {
        setLoading(false);
      }
      );
  }, []);

  if (loading) {
    return <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}><Loader /></div>;
  }

  return <div data-testid="swagger-ui">
    <SwaggerUI requestInterceptor={swaggerRequestInterceptor} spec={apiSpec}/>
  </div>;
};
